import React from 'react';
import PropTypes from 'prop-types';

import './ProgressRing.scss';

const propTypes = {

	/**
	 * The width of the square svg element.
	 */
	width: PropTypes.number,

	/**
	 * The stroke width.
	 */
	stroke: PropTypes.number,

	/**
	 * The amount of progress to display (as a percentage).
	 */
	progress: PropTypes.number,

	/**
	 * True, if the progress ring should be animated.
	 */
	animate: PropTypes.bool,

};

class ProgressRing extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			fill: 0,
		};

	}

	componentDidMount() {

		const { progress, animate } = this.props;

		const { fill } = this.state;

		if (animate && fill !== progress) {

			// trigger animation on next available screen repaint
			requestAnimationFrame(() => this.setState({ fill: progress }));

		}

	}

	componentDidUpdate(prevProps) {

		const { progress, animate } = this.props;

		const { fill } = this.state;

		if (animate && fill !== progress && prevProps.progress !== progress) {

			// trigger animation on next available screen repaint
			requestAnimationFrame(() => this.setState({ fill: progress }));

		}

	}

	render() {

		const { width, stroke, progress, animate } = this.props;

		const { fill } = this.state;

		const radius = width / 2;

		const innerRadius = radius - (stroke / 2);

		const circumference = innerRadius * 2 * Math.PI;

		const progressValue = animate ? fill : progress;

		const strokeDashoffset = circumference - (progressValue / 100 * circumference);

		return (
			<svg
				className="progress-ring-container"
				height={width}
				width={width}>
				<circle
					className="progress-ring-background"
					strokeWidth={stroke}
					r={innerRadius}
					cx="50%"
					cy="50%" />
				<circle
					className={`progress-ring ${animate ? 'animate' : ''}`}
					strokeWidth={stroke}
					strokeDasharray={`${circumference} ${circumference}`}
					style={{ strokeDashoffset }}
					r={innerRadius}
					cx="50%"
					cy="50%" />
			</svg>
		);
	}

}

ProgressRing.propTypes = propTypes;

export default ProgressRing;
